export enum MembersViewState {
  DEFAULT = 'DEFAULT',
  NO_EVENTS = 'NO_EVENTS',
  DETAILS = 'DETAILS',
}

export enum MembersSettingsEventsKeys {
  ForceView = 'forceView',
}

export interface SettingsEvents {
  forceView: MembersViewState
}
